module.exports = __webpack_public_path__ + "static/media/releases.c470454a.svg";